export const FILE_SIZE = {
  MB_1: 1,
  MB_5: 5,
  MB_25: 25,
  MB_10: 10,
  MB_500: 500,
};

export const MB_IN_BYTES = {
  MB_25: 26214400,
};
